import { render, staticRenderFns } from "./card.vue?vue&type=template&id=0e0e2de5&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style0 from "./card.vue?vue&type=style&index=0&id=0e0e2de5&prod&lang=scss&scoped=true"
import style1 from "./card.vue?vue&type=style&index=1&id=0e0e2de5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0e2de5",
  null
  
)

export default component.exports